import React from 'react';
import { StyledCard, StyledContainer, StyledDiv } from './WhyChooseUs.styled';

const WhyChooseUs = ({ data }) => {
  return (
    <StyledCard
      style={{
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      background={data.technology.background}
      textColor={data.technology.textColor}
    >
      <StyledContainer
        positionStyle={data.technology.isStyle}
        className='container'
      >
        <StyledDiv colors={data?.technology?.textColor} className='left'>
          <h1 className='info'>{data?.technology.info}</h1>
          <h3 className='title_wh'>{data?.technology.title1}</h3>
          <h3 className='title_or'>{data?.technology.title2}</h3>
          {data?.technology?.content?.map(({ title, details, img }, index) => {
            return (
              <StyledDiv
                className='content'
                key={index}
                style={{
                  margin: data.technology?.customContentStyle
                    ? '4px 0px'
                    : '12px 0px',
                }}
              >
                {img && (
                  <img
                    src={img}
                    className='iconImage'
                    loading='lazy'
                    style={{
                      width: data.technology?.customContentStyle?.iconSize,
                      height: data.technology?.customContentStyle?.iconSize,
                    }}
                  />
                )}
                <StyledDiv>
                  <StyledDiv
                    className='title_mid'
                    style={{
                      fontSize: data.technology?.customContentStyle?.textSize,
                    }}
                  >
                    {title}
                  </StyledDiv>
                  <StyledDiv className='title_s'>{details}</StyledDiv>
                </StyledDiv>
              </StyledDiv>
            );
          })}
        </StyledDiv>
        <StyledDiv className='right'>
          <img
            src={data.technology.heroImage}
            alt='Hero Image'
            loading='lazy'
            className={
              data.technology.isStyle ? 'hero_img imageStyle' : 'hero_img'
            }
          />
        </StyledDiv>
      </StyledContainer>
    </StyledCard>
  );
};

export default WhyChooseUs;
